var SelectDataSourceController = require('./SelectDataSourceController.js').default;

function SelectDataSourceDirective() {
	return {
		restrict: 'E',
		scope: {
			'model': '=ngModel',
			'store': '=',
			'onSelect': '&',
			'onChange': '&',
			'disabled': '='
		},
		controller: SelectDataSourceController,
		require: 'ngModel',
		controllerAs: 'vm',
		templateUrl: '/package/system/dashboard/view.SelectSource.html',
		link: function(scope, el, attr, ctrl) {
			scope.vm.ngModelController = ctrl;
			el[0].setSelectedSource = function(source){
				scope.vm.selectedSource = source;
			}
		}
	}
}

module.exports = SelectDataSourceDirective;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/SelectDataSourceDirective.js